
import { defineComponent, inject } from "vue";

export default defineComponent({
  props: {
    id: {
      type: String,
    },
  },
  setup() {
    const isCollapsed = inject("isCollapsed");

    return { isCollapsed };
  },
});
